// The caller's Company reusable-artwork library, and the reuse (attach) action.
//
// A repeat order shouldn't force a re-upload of a file Argo already holds. The
// backend resolves the Company server-side from the verified token, asks Nexus
// for that Company's files, and returns a customer-safe subset (filenames + a
// display reference; no cost data, no internal ids). Picking one POSTs the
// object_key back and gets a normal AssetDto in return — the blob is
// content-addressed and already stored, so no bytes move.
//
// Not pricing data, so the SPA MAY cache the LIST briefly (TanStack Query
// staleTime at the call site) — CLAUDE.md §Caching permits caching non-price
// company data.

import type { AssetDto, ComponentRole, ReusableAsset } from 'shared';

import { api } from './client.js';

export async function getReusableArtwork(): Promise<ReusableAsset[]> {
  const res = await api.get<{ assets: ReusableAsset[] }>('/companies/reusable-artwork');
  return res.data.assets;
}

// Attach an already-stored file to this quote + slot. The backend re-checks that
// the object_key really is in the caller's Company library (404 otherwise), so
// this is a reference, never a trusted client assertion.
export async function reuseArtwork(args: {
  quote_id: string;
  quote_line_id?: string | null;
  component_role: ComponentRole;
  object_key: string;
}): Promise<AssetDto> {
  const res = await api.post<{ asset: AssetDto }>('/storage/reuse', {
    quote_id: args.quote_id,
    quote_line_id: args.quote_line_id ?? null,
    component_role: args.component_role,
    object_key: args.object_key,
  });
  return res.data.asset;
}
